module.exports = __webpack_public_path__ + "static/YingZhang-78cea1c6dfd73693160037072492e0d8.jpg";